// 9fbef606107a605d69c0edbcd8029e5d
import GLOBAL_CONSTANTS from '../constants';

const MAX_KEYS = 15;

const PromoCombinationReducer = (state = {}, action = '') => {
  switch (action.type) {
    case GLOBAL_CONSTANTS.LOAD_PROMO_COMBINATION_DATA: {
      const newPromoCombinations = { ...state, [action.cid]: { ...action.payload } };
      const keys = Object.keys(newPromoCombinations);
      if (keys.length > MAX_KEYS) {
        const keysToRemove = keys.slice(0, keys.length - MAX_KEYS);
        keysToRemove.forEach((key) => {
          delete newPromoCombinations[key];
        });
      }
      return {
        ...newPromoCombinations,
      };
    }
    default:
      return state;
  }
};

export default PromoCombinationReducer;
